declare global {
    interface Window {
        Master: any;
        RootURL: string;
        Frontend: any;
        LabelPrinter: any;
    }
}

export const RootURL = window.RootURL;
export const $ = window.$;
export const LabelPrinter = window.LabelPrinter;